export default [
  {
    name: "Español",
    competence: "Nativo",
  },
  {
    name: "Inglés",
    competence: "Técnico",
  },
];
